import { ApiBase } from "@/api/ApiBase";

export class IntegracaoApi extends ApiBase {}
